import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=c0f5b3a2&"
import script from "./LoginCard.vue?vue&type=script&lang=ts&"
export * from "./LoginCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports